'use client';
import { useState } from 'react';

import classes from './Faq.module.css';
import { Plus, Minus } from 'react-feather';

const Faq = (props) => {
	const { productPage } = props;
	const [option, setOption] = useState();

	const showOptionsHandler = (f) => {
		if (option && option.question === f.question) {
			setOption();
		} else {
			setOption(f);
		}
	};
	const faqs = [
		{
			question: 'Can I see an item before purchasing?',
			answer:
				'Yes, you can send a pick up request to the seller for any item that you would like to see first. If you decide not to take the product home with you, cancel your request from your account and we will remove the temporary hold on your card. You can also add shipping for any pick up order from your orders page.',
		},
		{
			question: 'Can I reserve an item?',
			answer:
				'Yes, you can reserve an item by sending a purchase request to the seller. Schedule pickup/delivery at your conveninece, ',
		},
		{
			question: 'Do you deliver?',
			answer:
				"Yes, we offer insured shipping across the country by comparing the best quotes from over 300 carriers. Shop with ease, and we'll handle the logistics for you, no matter where you are in the country!",
		},
		{
			question: 'Who is selling this item?',
			answer:
				'All items on Kashew are sold by professional resellers. Mostly consignment stores and furniture warehouses. If you want to get more details about a specific product, send a question to the seller directly.',
		},
		{
			question: 'Is the item still available?',
			answer:
				"To ensure an up-to-date catalog, all listings on Kashew expire within 30 days. Additionally, we won't charge your card until the seller confirms the sale, giving you peace of mind and ensuring a smooth and secure transaction.",
		},
		{
			question: 'Can I chat with the seller?',
			answer:
				"Yes, after sending a purchase request the seller has 72 hours to accept. Once the seller accepts the request, you'll be able to chat with them directly. If you have a product-related question, you can post it on the public forum on the listing page and wait for the seller to reply. We aim to make communication easy, safe and convenient for both buyers and sellers on our platform.",
		},
		{
			question: 'How does the money back guarantee work?',
			answer:
				"If you spot any discrepancies within 48 hours of delivery, simply send us an email at support@kashew.com. We offer a satisfaction guarantee, so you can get your money back and return the item free of charge. We take pride in ensuring our customers are completely satisfied with their purchases, so don't hesitate to reach out if you encounter any issues",
		},
	];

	const faqHowItWorks = [
		{
			question: 'Can I chat with the seller?',
			answer:
				"Absolutely, once the seller approves your offer or purchase request, you're able to engage in direct communication. For any questions regarding the item, feel free to inquire on the product page before making an offer.",
		},
		{
			question: 'Can I see the item before purchasing?',
			answer:
				'Yes, you may request to pick up and view the item. If it doesn’t meet your expectations, simply cancel the order from your orders page for an immediate full refund.',
		},
		{
			question: 'Contacting Customer Support',
			answer:
				'Reach out to us at support@kashew.com or call (213) 556-2728 for assistance with any inquiries or concerns.',
		},
		{
			question: 'How do I reschedule a delivery?',
			answer:
				'To reschedule a delivery, contact Kashew Customer Support or use the rescheduling feature on your orders page.',
		},
		{
			question: 'Ask the seller a question',
			answer:
				'For detailed information about an item, post your questions on the product page where the seller can respond with insights.',
		},
		{
			question: 'How do I cancel an order?',
			answer:
				'Orders can be cancelled directly from your orders page, with a full refund issued promptly, provided the item has not yet been shipped.',
		},
		{
			question: 'How do offers work?',
			answer:
				'Make a binding offer on selected items. Upon acceptance by the seller, payment is processed, yet the seller is only paid after you confirm satisfaction with the item received.',
		},
		{
			question: 'What are the shipping methods and costs?',
			answer:
				"We've teamed up with leading carriers like uShip, GoShare, and FedEx to provide you with competitive shipping quotes. Just enter your address on the product page to receive the best available rate.",
		},
	];

	return (
		<>
			<div className={classes.faqBox}>
				<div className={classes.titleP}>Frequently Asked Questions</div>
				<div className={classes.qandA}>
					{productPage
						? faqs.map((f, idx) => (
								<div
									key={idx}
									className={
										faqs.length === idx + 1 ? classes.boxFinal : classes.box
									}
								>
									<h6
										onClick={() => showOptionsHandler(f)}
										className={classes.subTitleP}
									>
										{option && option.question === f.question ? (
											<Minus className={classes.icon} />
										) : (
											<Plus className={classes.icon} />
										)}{' '}
										{f.question}
									</h6>
									{option && option.question === f.question && (
										<div className={classes.muteTextP}>{f.answer}</div>
									)}
								</div>
						  ))
						: faqHowItWorks.map((f, idx) => (
								<div
									key={idx}
									className={
										faqHowItWorks.length === idx + 1
											? classes.boxFinal
											: classes.box
									}
								>
									<h6
										onClick={() => showOptionsHandler(f)}
										className={classes.subTitleP}
									>
										{option && option.question === f.question ? (
											<Minus className={classes.icon} />
										) : (
											<Plus className={classes.icon} />
										)}{' '}
										{f.question}
									</h6>
									{option && option.question === f.question && (
										<div className={classes.muteTextP}>{f.answer}</div>
									)}
								</div>
						  ))}
				</div>
			</div>
		</>
	);
};

export default Faq;
